module.exports = __webpack_public_path__ + "img/home21.139f3fdc.png";